export class DevicePinColorHelper {
  public static getRadioLevelPinColor(radioLevelValue: number): string {
    if (radioLevelValue >= -60 && radioLevelValue <= -50) {
      return '7CCA6F';
    } else if (radioLevelValue >= -70 && radioLevelValue < -60) {
      return 'AFE400';
    } else if (radioLevelValue >= -80 && radioLevelValue < -70) {
      return 'FFF500';
    } else if (radioLevelValue >= -88 && radioLevelValue < -80) {
      return 'F58C2D';
    } else if (radioLevelValue >= -109 && radioLevelValue < -88) {
      return 'E75D70';
    } else if (radioLevelValue < -200) {
      return 'C76CCF';
    } else {
      return '96A5AF';
    }
  }

  public static getSignalQualityPinColor(signalQualityValue: number): string {
    switch (signalQualityValue) {
      case 0:
        return '7CCA6F';
      case 1:
        return 'AFE400';
      case 2:
        return 'FFF500';
      case 3:
        return 'F58C2D';
      case 4:
        return '96A5AF';
      default:
        return '96A5AF';
    }
  }
}
